import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "../../images/logo_black.png";
import { REACT_APP_API_BASE_URL } from '../../env.js';

const DeleteAccount = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();

    if (!confirmed) {
      Swal.fire({
        title: 'Confirmation Required',
        text: 'Please check the confirmation box before proceeding.',
        icon: 'info'
      });
      return;
    }

    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "This will permanently delete your account and all data!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (confirm.isConfirmed) {
      setLoading(true);
      try {
        const apiUrl = REACT_APP_API_BASE_URL || 'https://api.somado.me';
        await axios.post(`${apiUrl}/user/delete-by-email`, { email });

        Swal.fire({
          title: 'Deleted!',
          text: 'Your account has been deleted.',
          icon: 'success',
          timer: 3000,
          showConfirmButton: false
        });
        setEmail('');
        setConfirmed(false);
      } catch (err) {
        Swal.fire({
          title: 'Error',
          text: err.response?.data?.message || 'Failed to delete account. Please try again later.',
          icon: 'error'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light py-5">
      <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <div className="card shadow-lg border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
          {/* Header Section */}
          <div className="text-white text-center py-5 px-4" style={{ backgroundColor: '#f06262' }}>
            <div className="d-inline-flex align-items-center justify-content-center bg-white rounded-circle mb-3 shadow-sm" style={{ width: '90px', height: '90px' }}>
              <img src={logo} alt="W" style={{ width: '60px', objectFit: 'contain' }} />
            </div>
            <h1 className="fw-bold mb-2" style={{ fontSize: '2.5rem' }}>Account Deletion</h1>
            {/* <p className="mb-0 fs-5">We're sorry to see you go</p> */}
          </div>

          <div className="card-body p-4 p-md-4 bg-white">
            {/* Warning Notice Section */}
            <div className="p-4 mb-4 rounded" style={{ backgroundColor: '#fffdf0', border: '1px solid #f9e8a5' }}>
              <div className="d-flex align-items-start mb-3">
                <span className="text-warning me-2" style={{ fontSize: '1.2rem' }}>⚠️</span>
                <h5 className="fw-bold mb-0" style={{ color: '#856404', fontSize: '1.1rem' }}>Before you proceed</h5>
              </div>
              <ul className="mb-0 ps-4" style={{ color: '#967305', fontSize: '0.95rem', listStyleType: 'disc' }}>
                <li className="mb-2">Your Somadome account and all associated data will be permanently deleted.</li>
                <li className="mb-2">You will lose all your session history, progress, and personalized dome settings.</li>
                {/* <li className="mb-2">Ensure any active memberships or subscriptions are cancelled before proceeding.</li> */}
                <li>All your booked sessions and feedback history will be irreversibly removed.</li>
              </ul>
            </div>

            <form onSubmit={handleDelete}>
              {/* Verification Box */}
              <div className="p-4 mb-4 border rounded bg-white shadow-sm" style={{ borderColor: '#e9ecef' }}>
                <div className="d-flex align-items-center mb-3">
                  <h6 className="fw-bold mb-0 text-dark">Email Verification</h6>
                </div>
                <div className="mb-2">
                  <input
                    type="email"
                    className="form-control form-control-lg border-2"
                    style={{ borderColor: '#dee2e6', fontSize: '0.95rem' }}
                    placeholder="Enter your registered email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {/* <small className="text-muted" style={{ fontSize: '0.85rem' }}>We'll verify your account with this email</small> */}
              </div>

              {/* Confirmation Checkbox Box */}
              <div className="p-4 mb-4 border rounded bg-white shadow-sm d-flex align-items-start" style={{ borderColor: '#e9ecef' }}>
                <div className="pt-1">
                  <input
                    className="form-check-input me-3"
                    type="checkbox"
                    id="confirmDelete"
                    checked={confirmed}
                    onChange={(e) => setConfirmed(e.target.checked)}
                    style={{ cursor: 'pointer', width: '20px', height: '20px', border: '1px solid #adb5bd' }}
                  />
                </div>
                <label className="form-check-label text-dark" htmlFor="confirmDelete" style={{ cursor: 'pointer' }}>
                  <div className="fw-bold mb-1" style={{ fontSize: '1rem' }}>I understand that this action cannot be undone</div>
                  <div className="text-muted" style={{ fontSize: '0.9rem' }}>I confirm that I want to permanently delete my account and all associated data from the platform.</div>
                </label>
              </div>

              <button
                type="submit"
                className={`btn btn-lg w-100 py-3 fw-bold text-white shadow-sm`}
                disabled={loading || !confirmed}
                style={{
                  borderRadius: '6px',
                  backgroundColor: confirmed ? '#f06262' : '#d2d6da',
                  borderColor: confirmed ? '#f06262' : '#d2d6da',
                  transition: 'all 0.3s ease',
                  fontSize: '1.1rem'
                }}
              >
                {loading ? (
                  <span>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </span>
                ) : 'Delete My Account'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
